<script lang="ts">
  import { _ } from "svelte-i18n";
  import { fly } from "svelte/transition";
  import { cubicOut } from "svelte/easing";
  import cfg from "$lib/config/config";
  import { recommendations } from "$lib/stores/recommendations";
  import type { PageType } from "$lib/stores/recommendations";
  import { regionStore } from "$lib/stores/region";
  import { get } from "svelte/store";
  import {
    type Product,
    type NostoRecommendation,
    dynamicBundleProducts,
  } from "$lib/utils/dynamicBundle";
  import CartBundleCard from "$lib/components/Nosto/DynamicBundle/MiniBag/CartBundleCard.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let pageType: PageType;

  let recommendationData: undefined | NostoRecommendation;
  export let input;
  let show = false;
  let products: Product[] = [] as Product[];
  let nostoTitle: string;

  const { productIds = [], variantId, placement } = input;

  const isBrowser = typeof window !== "undefined";

  const regionInfo = regionStore();

  const locale = get(regionInfo).locale;

  let lang = locale;
  lang = lang && lang.split("-")[0];

  productIds.forEach((pid: string) => {
    if (isBrowser && window.nostojs) {
      window.nostojs(api => {
        recommendations.setUser();
        recommendations.setCart();

        switch (pageType) {
          case "PDP":
            return api
              .defaultSession()
              .setResponseMode("JSON_ORIGINAL")
              .viewProductSku(
                pid?.split("/").slice(-1)[0],
                variantId?.split("/").slice(-1)[0],
              )
              .setPlacements([placement])
              .load()
              .then((res: any) => {
                const dynBund = dynamicBundleProducts(
                  recommendations.transformRecPlacements(
                    Object.values(res.recommendations)[0],
                    lang,
                  ),
                );
                dynBund.then((prods: Product[]) => {
                  products = [...products, ...prods];
                  return (recommendationData =
                    recommendations.transformRecPlacements(
                      Object.values(res.recommendations)[0],
                      lang,
                    ));
                });
              });
          default:
            break;
        }
      });
    }
  });

  $: recommendations.updatedRecommendations({
    ...(recommendationData as any),
    pageType,
  }),
    recommendationData;

  $: (show = cfg.NOSTO_SHOW_RECS && recommendationData?.products?.length > 0),
    recommendationData;

  $: if (recommendationData) nostoTitle = recommendationData.resultTitle;
</script>

<style lang="scss">
  .dynamic-bundle-container {
    padding-top: 40px;
    width: 325px;
    display: flex;
    flex-direction: column;
    gap: 36px;
    padding: 1.75rem;
    position: absolute;
    right: 0;
    top: 0;
    background: #f7f7f7;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>

{#if products && products.length}
  <div
    class="dynamic-bundle-container"
    data-placement-id={recommendationData.resultId}
    transition:fly={{ x: 300, duration: 500, delay: 300, easing: cubicOut }}
  >
    <div class="dynamic-bundle-header">
      <Typography component="h3" variant="h3-1">
        {$_("You might also like")}
      </Typography>
    </div>
    {#each products as p, i (i)}
      <CartBundleCard product={p} {products} />
    {/each}
  </div>
{/if}
